import React from "react";
import Helmet from "react-helmet";
import Archives from "./archives.js";

export default class CategoryTemplate extends React.Component {
  render() {
    const category = this.props.pathContext.category;
    const categories = this.props.pathContext.categoryArray;
    const edges = this.props.data.allMarkdownRemark.edges;
    const siteTitle = this.props.data.site.siteMetadata.title;
    return (
      <section className="category-container">
        <Helmet
          title={`#${category} | ${siteTitle}`}
        />
        <Archives edges={edges} category={category} categories={categories}/>
      </section>
    );
  }
}


export const pageQuery = graphql`
  query CategoryPage($category: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      totalCount
      edges {
        node {
          frontmatter {
            category
            number
            title
            date
            images
          }
          html
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/category.js